// @flow

import * as React from "react";
import { FormSpy, type FormSpyRenderProps } from "react-final-form";
import { type FormSubscription } from "final-form";

type ConditionalSubformProps = {
  condition: FormSpyRenderProps => boolean,
  renderOnSatisfy: FormSpyRenderProps => React.Node,
  renderOnFail: FormSpyRenderProps => React.Node,
  subscription: FormSubscription
};

const ConditionalSubform = ({
  condition,
  renderOnSatisfy,
  renderOnFail,
  subscription
}: ConditionalSubformProps) => (
  <FormSpy
    subscription={subscription}
    render={(state: FormSpyRenderProps) =>
      (condition(state) ? renderOnSatisfy : renderOnFail)(state)
    }
  />
);

ConditionalSubform.defaultProps = {
  subscription: {},
  renderOnSatisfy: () => null,
  renderOnFail: () => null
};

export default ConditionalSubform;
